import * as Sentry from "@sentry/react";

import { tryAcquireReloadPermit } from "../app-reload/reload-permit";
import { reloadWindow } from "../app-reload/reload-window";
import { isChunkLoadError } from "./is-chunk-load-error";

const SENTRY_FLUSH_TIMEOUT_MS = 2_000;

let isReloadInProgress = false;

export function attemptChunkLoadRecovery(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  if (isReloadInProgress) {
    return true;
  }

  const hasReloadPermit = tryAcquireReloadPermit();
  if (!hasReloadPermit) {
    // A reload already happened recently and did not fix it: stale CDN edge or real outage
    Sentry.captureException(error, { level: "error", tags: { chunk_recovery: "give-up" } });
    return false;
  }

  isReloadInProgress = true;
  Sentry.captureException(error, { level: "warning", tags: { chunk_recovery: "reload" } });
  Sentry.flush(SENTRY_FLUSH_TIMEOUT_MS)
    .catch(function ignoreFlushError() {
      return false;
    })
    .then(function reloadAfterFlush() {
      reloadWindow();
    });

  return true;
}
